export const ERRORS = {
  zipcode: {
    required: () => `Kod pocztowy jest wymagany do lokalizacji`,
    zipCode: () => `Podaj poprawny kod pocztowy`
  },
  phone: {
    required: () => `Podaj numer telefonu. Nikomu go nie przekażemy`,
    phoneNumber: () => `Podaj poprawny numer telefonu`
  },
  term: {
    required: () => `Zaakceptuj regulamin by przejść dalej`
  }
}
